import script from "./ContentName.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentName.vue?vue&type=script&lang=ts&setup=true"

import "./ContentName.vue?vue&type=style&index=0&id=4c5fcbe3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5fcbe3"]])

export default __exports__